export function fullName(persona: any) {
  if (persona) {
    return `${persona.nombre} ${persona.apellidoPaterno} ${persona.apellidoMaterno ?? ''}`.trim();
  }
  return '';
}

/**
 * Función que sólo permite capturar números.
 * @param evt
 * @returns
 */
export function onlyNumbers(evt): boolean {
  const charCode = evt.which ? evt.which : evt.keyCode;
  if (charCode > 47 && charCode < 58) {
    return true;
  } else {
    evt.preventDefault();
  }
}

/**
 * Remueve los acentos
 * @param str
 * @returns string
 */
export function removeAccents(str: string): string {
  return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
}

/**
 * Función que solo permite la captura de números enteros o decimales,
 * permite solo añadir un punto decimal y un signo negativo.
 *
 * @param evt
 * @returns
 */
export function soloEnterosDecimales(evt): boolean {
  const input = evt.target as HTMLInputElement;
  const value = input.value;
  const key = evt.key;

  // Permitir números (0-9)
  if (/^\d$/.test(key)) {
    return;
  }

  // Permitir un único punto (.) si no está presente
  if (key === '.' && !value.includes('.')) {
    return;
  }

  // Permitir un único signo negativo (-) solo al principio
  if (key === '-' && value.length === 0) {
    return;
  }

  // Permitir teclas de navegación: backspace, arrows, delete, etc.
  const allowedKeys = ['Backspace', 'ArrowLeft', 'ArrowRight', 'Delete', 'Tab'];
  if (allowedKeys.includes(key)) {
    return;
  }

  // Bloquear cualquier otra tecla
  evt.preventDefault();
}

export function onlyNumbersV2(evt: KeyboardEvent): boolean {
  const allowedControlKeys = ['Backspace', 'Tab', 'ArrowLeft', 'ArrowRight', 'Delete'];

  if (allowedControlKeys.includes(evt.key)) {
    return true;
  }

  if (/^\d$/.test(evt.key)) {
    return true;
  }

  evt.preventDefault();
  return false;
}

export function onlyLettersSingleSpace(evt: KeyboardEvent): boolean {
  const key = evt.key;
  const input = evt.target as HTMLInputElement;

  const controlKeys = ['Backspace', 'Tab', 'ArrowLeft', 'ArrowRight', 'Delete'];
  if (controlKeys.includes(key)) return true;

  if (key === ' ') {
    if (input.value.endsWith(' ')) {
      evt.preventDefault();
      return false;
    }
    return true;
  }

  if (/^[a-zA-Z]$/.test(key)) return true;

  evt.preventDefault();
  return false;
}
